import { render, staticRenderFns } from "./Duo.vue?vue&type=template&id=e826cc48&"
import script from "./Duo.vue?vue&type=script&lang=js&"
export * from "./Duo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports